import React, { useEffect, useState } from "react";
import CustomButton from "../shared/CustomButton";
import {
  AddPlus,
  AddressContainer,
  AddressesService,
  CAMPAIGN_OPTION_WALLET_TYPE,
  ChevronRight,
  ClientContainer,
  formatNumber,
  getCartTotalValue,
  getCartWalletIsFixedType,
  getCartWalletType,
  RemoveMinus,
  ShoppingCart02,
  Trash,
  withContainers,
} from "../normalizer";

import {
  CampaignUserContainer,
  ShoppingCartContainer,
} from "../../containers/gamification2026";

import CartWarning from "./CartWarning";
import NewAddressForm from "../shared/Address/NewAddressForm";

const CartAddresses = (props) => {
  const {
    cart,
    onCheckCartItem,
    campaignUser,
    addresses,
    onUpdateAddress,
    onCheckAddresses,
    onNewAddressCreation,
    states,
    errors,
    campaign,
    countries,
    selectedState,
    selectedCountry,
    onCountryChange,
    onStateChange,
    allDigitalCards,
  } = props;


  function getAddresses(){
    AddressesService.getAddresses(allDigitalCards).then((response) => {
      const addresses = response.data
      debugger
      props.saveAddresses(addresses);
    });
  }

  useEffect(()=>{
    getAddresses();
  }, [])

  const [addressFormVisible, setAddressFormVisible] = useState(false);
  const showMonetaryValue =
    getCartWalletType(cart) === CAMPAIGN_OPTION_WALLET_TYPE &&
    getCartWalletIsFixedType(cart) === false;

  const handleNewAdressCreation = (data) => {
    data.callBack = () => setAddressFormVisible(false);
    
    if (allDigitalCards) {
      data.is_virtual  = true;
    }
    onNewAddressCreation(data);
  };

  console.warn(`CartAddresses - shipment_address => `, cart.shipment_address);
  const isSelected = (item) => {
    return (
      cart &&
      cart.shipment_address &&
      item.address1 === cart.shipment_address.address1 &&
      item.address2 === cart.shipment_address.address2 &&
      item.city === cart.shipment_address.city &&
      item.zip_code === cart.shipment_address.zip_code &&
      item.email === cart.shipment_address.email &&
      item.phone === cart.shipment_address.phone
    );
  };

  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <div className="cart-addresses">
      <div className="cart-container">
        <div className="cart-container-content">
          {addressFormVisible ? (
            <NewAddressForm
              errors={errors}
              availableStates={states}
              availableCountries={countries}
              state={selectedState}
              country={selectedCountry}
              onAddressCreationCancel={() => setAddressFormVisible(false)}
              onNewAddress={handleNewAdressCreation}
              onCountryChange={onCountryChange}
              onStateChange={onStateChange}
              isVirtual={allDigitalCards}
            />
          ) : (
            <>
              <fieldset className="cart-container-addresses">
                <legend className="cart-container-address-legend">
                  Selecione os dados de envio da entrega:
                </legend>
                {addresses.map((item) => (
                  <div
                    key={item.id}
                    className={`cart-container-address ${
                      isSelected(item) ? "cart-container-address--selected" : ""
                    }`}
                  >
                    <label className="cart-container-address-label">
                      <input
                        className="cart-container-address-radio"
                        type="radio"
                        name="cart-container-address"
                        value={item.id}
                        checked={isSelected(item)}
                        onChange={() => onUpdateAddress(item)}
                      />
                      <div className="cart-container-address-info">
                        <div className="cart-container-address-nome">
                          {item.first_name} {item.last_name}
                        </div>
                        <div className="cart-container-address-container">
                          {!item.is_virtual ? <div className="cart-container-address-morada">
                            {item.address1}, {item.address2}
                          </div>: null}
                          {!item.is_virtual ? <div className="cart-container-address-cpostal">
                            {item.city}, {item.zip_code}
                          </div> : null}
                          <div className="cart-container-address-email">
                            {item.email}
                          </div>
                          <div className="cart-container-address-phone">
                            {item.phone}
                          </div>
                        </div>
                      </div>
                    </label>
                  </div>
                ))}
              </fieldset>
              <CustomButton
                left
                secondary
                onClick={() => setAddressFormVisible(true)}
              >
                <AddPlus />
                Adicionar dados de envio
              </CustomButton>
            </>
          )}
        </div>
        <div className="cart-container-checkout">
          <ShoppingCart02 className="cart-container-checkout-icon" />
          <div className="cart-container-checkout-group">
            <div className="cart-container-checkout-title1">Total</div>
            <div className="cart-container-checkout-total">
              {showMonetaryValue
                ? `${formatNumber(cart.total_points)} pontos = ${formatNumber(getCartTotalValue(cart))}€`
                : `${formatNumber(cart.total_points)} pontos`}
            </div>
          </div>
          <div className="cart-container-checkout-group">
            <div className="cart-container-checkout-title2">
              Pontos disponíveis
            </div>
            <div className="cart-container-checkout-available-points">
              {formatNumber(campaignUser.availablePoints)} pontos
            </div>
          </div>
          {onCheckCartItem ? (
            <CustomButton
              className="cart-container-checkout-button"
              onClick={() => onCheckAddresses()}
            >
              Avançar
              <ChevronRight />
            </CustomButton>
          ) : null}
          {campaignUser && cart.total_points > campaignUser.availablePoints && (
            <CartWarning
              header={`${formatNumber(cart.total_points - campaignUser.availablePoints)} pontos em falta`}
              text="Os pontos em falta serão pagos por copagamento"
            />
          )}
        </div>
      </div>

    </div>
  );
};

export default withContainers(CartAddresses, [
  CampaignUserContainer,
  AddressContainer,
  ShoppingCartContainer,
]);
